module.exports = __webpack_public_path__ + "static/triogrotesk-medium-v102-630412ceac1db4133ee1b1797f41cb9b.woff2";